import {defaultModel, internalDefaultModel} from "@buildwithflux/models";

export function getDefaultModel(isFluxOrgMember: boolean) {
    if (isFluxOrgMember) {
        return internalDefaultModel;
    } else {
        return defaultModel;
    }
}
